/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Cookies from 'js-cookie';
import UserHeader from './Parts/Header/Header-User';
import GuestHeader from './Parts/Header/Header-Guest';
import Sidebar from './Parts/Sidebar';
import Footer from './Parts/Footer';
import Carousel from './Parts/Carousel';

import PrivacyPolicy from './Parts/Sidebar/PrivacyPolicy';
import socket from '../../Socket';
import { Event, decode, encode, wait, isMobile } from '../../Helper';
import WalletAlert from '../Components/User/Wallet/Alert';
import C from '../../Constant';
import Login from './Auth/Login';
import storage from '../../Storage';
import Engine from '../Games/Crash/Engine';
import Canvas from '../Games/Crash/Graphic';
import MobileCanvas from '../Games/Crash/Graphic/Mobile';
import CanvasSpin from '../Games/Crash/Spin/index';
import Mobi from '../Games/Crash/Graphic/Mobi';
import Bet from '../Games/Crash/Bet';
import Bet1 from '../Games/Crash/Bet1';
import Queue from '../Games/Crash/Queue';
import Queue2 from '../Games/Crash/Queue2';
import QueueSpin from '../Games/Crash/QueueSpin';
import Players from '../Games/Crash/Players';
import Players_spin from '../Games/Crash/Players';
import Menus from '../Games/Crash/includes/Menus';
import Affiliate from '../Pages/Affiliate';
import HistoryList from '../Games/Crash/includes/HistoryList';
import MobileBottomNav from './Parts/MobileBottomNav';
import Wallet from '../Components/User/Wallet/Wallet';

class Index extends React.Component {
  _Mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      mobile: false,
      isLogged: false,
      bid: '',
      token: false,
      header: <GuestHeader t={this.props.t} location={this.props.location} />,
      // header: <UserHeader t={this.props.t} location={this.props.location} />,
      auth: false,
      code: '',
      betAmounts: [0, 0, 0, 0],
      placedBets: [],
      activeTab: 'crash',
      showWalletModal: false,
      walletTabIndex: 0,
      showUserDropdown: false,
      showChatSidebar: false,
    };
    this.headerRef = React.createRef();
    this.handleResize = this.handleResize.bind(this);
    this.handleWalletClick = this.handleWalletClick.bind(this);
    this.handleTradesClick = this.handleTradesClick.bind(this);
    this.handleChatClick = this.handleChatClick.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  componentWillMount() {
    wait(500).then(() => {
      this._Mounted = true;
    });
  }

  componentDidMount() {
    // Check route for deposit modal
    this.checkRoute();

    // Initial check for existing token to set logged-in state immediately
    if (storage.getKey('token')) {
      wait(500).then(() => {
        if (this._Mounted) {
          this.setState({
            header: <UserHeader t={this.props.t} location={this.props.location} />,
            isLogged: true,
            token: storage.getKey('token'),
            code: storage.getKey('code') || '',
          });
        }
        // Ensure auth cookie is set if missing
        if (!Cookies.get('auth')) {
          Cookies.set('auth', true, { expires: 14, path: '/' });
        }
      });
    }

    // Check for refresh flag
    const shouldRefresh = localStorage.getItem('shouldRefresh');
    if (shouldRefresh === 'true') {
      localStorage.removeItem('shouldRefresh'); // Clear flag immediately
      wait(500).then(() => {
        window.location.reload(); // Trigger single refresh
      });
      return;
    }

    socket.on(C.ONLINE, (data) => this.loginUser(decode(data)));

    wait(600).then(() => {
      this.handleResize();
    });
    window.addEventListener('resize', this.handleResize);

    // Initialize Crash game after session validation
    wait(1000).then(() => {
      if (this._Mounted && storage.getKey('token')) {
        Engine.getStatus();
      }
    });

    // Handle route updates - moved inside componentDidMount properly
    if (this.props.location && this.props.location.pathname) {
      this.checkRoute();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.checkRoute();
    }
  }

  checkRoute() {
    if (this.props.location.pathname === '/deposit') {
      if (!this.state.showWalletModal) {
        this.setState({ showWalletModal: true, walletTabIndex: 0 });
      }
    }
  }


  componentWillUnmount() {
    socket.off(C.ONLINE);
    window.removeEventListener('resize', this.handleResize);
    localStorage.removeItem('shouldRefresh');
  }

  activeAuth = (status) => {
    this.setState({ auth: status });
  };

  loginUser = (data) => {
    wait(500).then(() => {
      if (this._Mounted && data.status === true) {
        this.setState({
          header: <UserHeader t={this.props.t} location={this.props.location} />,
          isLogged: true,
          token: storage.getKey('token'),
          code: data.referral_code,
        });

        Cookies.set('uid', data.id, { expires: 14, path: '/' });
        Cookies.set('auth', true, { expires: 14, path: '/' });
        storage.setKey('name', data.name);
        storage.setKey('email', data.email);
        storage.setKey('credit', data.credit?.kshs ?? data.credit ?? 0);
        storage.setKey('avatar', data.avatar);
        storage.setKey('friends', data.friends);
        storage.setKey('room', data.room);
        storage.setKey('token', storage.getKey('token'));
        storage.setKey('code', data.referral_code);
      } else {
        wait(7000).then(() => {
          Cookies.remove('session', { path: '/' });
          Cookies.remove('auth', { path: '/' });
          storage.clear();
          this.setState({ auth: true, isLogged: false, token: false });
        });
      }
    });
  };

  getWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth;
  }

  handleResize() {
    if (this.getWidth() < 1540) {
      this.setState({ col: 'col-xl-12' });
      Event.emit('hide_games');
    } else {
      this.setState({ col: 'col-xl-9' });
      Event.emit('show_min_games');
    }

    if (isMobile()) {
      this.setState({ mobile: true, padding: 'p-0', ovh: 'ovh' });
    } else {
      this.setState({ mobile: false });
    }
  }

  handleWalletClick = () => {
    this.setState({ showWalletModal: true, walletTabIndex: 0 });
  };

  handleTradesClick = () => {
    this.setState({ showWalletModal: true, walletTabIndex: 2 });
  };

  handleChatClick = () => {
    this.setState({ showChatSidebar: !this.state.showChatSidebar });
  };

  handleMenuClick = () => {
    this.setState({ showUserDropdown: !this.state.showUserDropdown });
    Event.emit('open_user_sidebar');
  };

  closeWalletModal = () => {
    this.setState({ showWalletModal: false });
    if (this.props.location.pathname === '/deposit') {
      this.props.history.push('/');
    }
  };

  updateBetAmount = (index, amount) => {
    this.setState((prevState) => {
      const updatedBetAmounts = [...prevState.betAmounts];
      updatedBetAmounts[index] = parseFloat(amount);
      return { betAmounts: updatedBetAmounts };
    });
  };

  calculateTotalBetAmount = () => {
    return this.state.betAmounts.reduce((total, amount) => total + amount, 0);
  };

  handlePlaceBet = (index, amount) => {
    this.setState((prevState) => {
      const updatedPlacedBets = [...prevState.placedBets];
      updatedPlacedBets[index] = parseFloat(amount);
      return { placedBets: updatedPlacedBets };
    });
  };

  calculateTotalPlacedBetAmount = () => {
    return this.state.placedBets.reduce((total, amount) => total + (amount || 0), 0);
  };

  switchTab = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  setActiveTab = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  render() {
    let { auth, mobile, activeTab } = this.state;
    let { content } = this.props;
    let wallet;

    try {
      wallet = this.props.get_wallet.show;
    } catch (e) { }

    const { t } = this.props;
    const totalPlacedBetAmount = this.calculateTotalPlacedBetAmount();

    // Create header element with dropdown state
    const header = this.state.isLogged
      ? <UserHeader t={t} location={this.props.location} showUserDropdown={this.state.showUserDropdown} onToggleUserDropdown={(show) => this.setState({ showUserDropdown: show })} />
      : <GuestHeader t={t} location={this.props.location} />;

    return (
      <>
        {header}
        {auth && <Login justModal={true} t={t} />}
        <Affiliate justModal={true} />
        <div className="page-wrapper neural-network-bg" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <div className="page-content container-fluid p-0 d-flex flex-column" id={'page-content'} style={{ flex: 1 }}>
            <div className="content-section" style={{ flex: 1 }}>
              <div className="game-content">
                <div className="row m-0">
                  <div className="col-md-2 p-1">
                    <div className="chat-section">
                      <div className="m-0 p-0">
                        <Queue2 t={t} suffix="desktop" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 p-0">
                    {!mobile ?
                      <Canvas mobile={mobile} />
                      :
                      <MobileCanvas mobile={mobile} />
                    }
                  </div>
                  <div className="col-md-2 p-0">
                    <div className="d-bets">
                      <Bet
                        mobile={mobile}
                        token={this.state.token}
                        isLogged={this.state.isLogged}
                        bid="0"
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <Footer t={t} />
          </div>
        </div >
        {
          this.state.mobile && (
            <MobileBottomNav
              isLogged={this.state.isLogged}
              t={t}
              onWalletClick={this.handleWalletClick}
              onTradesClick={this.handleTradesClick}
              onChatClick={this.handleChatClick}
              onMenuClick={this.handleMenuClick}
            />
          )
        }
        {
          this.state.mobile && (
            <div className={`mobile-chat-sidebar ${this.state.showChatSidebar ? 'active' : ''}`}>
              <div className="mobile-chat-header">
                <span>CHAT</span>
                <button className="close-chat" onClick={this.handleChatClick}>
                  <i className="mdi mdi-close"></i>
                </button>
              </div>
              <div className="mobile-chat-body">
                <Queue2 t={t} suffix="mobile" />
              </div>
            </div>
          )
        }
        {
          this.state.showWalletModal && (
            <div className="modal d-block show fade wallet-modal-custom animated pulse" role="dialog">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="close" onClick={this.closeWalletModal}><i className='mdi mdi-close' ></i></button>
                  </div>
                  <div className="modal-body">
                    <Wallet initialTab={this.state.walletTabIndex} />
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </>
    );
  }
}

Index.propTypes = {
  get_wallet: PropTypes.shape({
    show: PropTypes.bool,
  }),
  t: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = (state) => ({
  get_wallet: state.items.get_wallet,
});

export default connect(mapStateToProps, null)(Index);